// extracted by mini-css-extract-plugin
module.exports = {"main":"bool-control_main__2sIjG"};